export enum ToastLevel {
    Error,      // 0
    Warning,    // 1
    Info,       // 2
    Success     // 3
}
